import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWifiNoSignal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWifiNoSignal"><Path d="M15.0788 15.139L12.001 12.0611L8.92271 15.1394L7.86205 14.0787L10.9403 11.0005L7.86133 7.9215L8.92199 6.86084L12.001 9.93981L15.0796 6.86122L16.1402 7.92188L13.0616 11.0005L16.1395 14.0784L15.0788 15.139Z" fill="currentColor"/><Path d="M13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWifiNoSignal;
